import { FC } from 'react';
import { SMPFlex, SMPSportIcon, SMPText, SMPContainer, SMPCountBadge } from '@velinsi/smp-widgets-ui';
import { SportTypes } from '../../../../../packages/types';
import { getIconAsBgImage } from '@sportal365/smp-widget-utils';

interface CompetitionGroupProps {
  name: string;
  topEvents?: boolean;
  logo?: string;
  eventCount?: number;
  onClick: () => void;
  isSelected?: boolean;
  isLast?: boolean;
}

export const MobileCompetitionGroup: FC<CompetitionGroupProps> = ({ eventCount, logo, topEvents, name, onClick, isSelected, isLast }) => {
  return (
    <SMPFlex
      style={{
        padding: '16px',
        width: '100%',
        borderBottom: isLast ? '' : '1px solid var(--colors-dropdownBorderColor)',
        backgroundColor: 'var(--colors-multiSportBgColor)',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
      onClick={onClick}
    >
      <SMPFlex style={{ gap: '8px', alignItems: 'center' }}>
        {topEvents && <SMPSportIcon sport={SportTypes.ALL} />}
        {logo && (
          <SMPContainer
            style={{
              backgroundImage: `url("${logo}")`,
              height: '16px',
              width: '16px',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              padding: 0,
              margin: 0,
            }}
          />
        )}
        {!logo && !topEvents && (
          <SMPContainer
            style={{
              backgroundImage: `url("${getIconAsBgImage('competition_placeholder')}")`,
              height: '20px',
              width: '20px',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              padding: 0,
              margin: 0,
            }}
          />
        )}
        <SMPText
          style={{
            lineHeight: '20px',
            fontWeight: 'bold',
            color: isSelected ? 'var(--colors-multisportHighlightColor)' : 'var(--colors-multiSportTextColor)',
            fontSize: '14px',
          }}
        >
          {name}
        </SMPText>
      </SMPFlex>
      {eventCount && <SMPCountBadge count={eventCount} />}
    </SMPFlex>
  );
};
